import { type KudoContentObjectList, type UploadedFile, createKudoContentObjectList } from 'models';
import { useMutation } from 'query';
import { updateKudo } from '../../services';
import { useContentObjectCache } from '../cache';

type UpdateKudoData = {
  attachments?: UploadedFile[];
  communityId?: string;
  htmlContent: string;
  id: string;
  pinned?: boolean;
  textContent: string;
};

export const useUpdateKudoMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<KudoContentObjectList, UpdateKudoData>({
    async mutationFn({ attachments, communityId, htmlContent, id, pinned, textContent }) {
      const response = await updateKudo({
        body: {
          kudo: {
            attachments: attachments?.map((attachment) => ({ id: attachment.id })),
            community_id: communityId,
            html_content: htmlContent,
            pinned,
            text_content: textContent,
          },
        },
        routeParams: { id },
      });

      return createKudoContentObjectList(response.data);
    },
    onSuccess(data) {
      cache.replace(data);
    },
  });
};
